import React, { useState } from 'react'
import SideBar from './SideBar'
import Header from './Header'

function MainLayout({ children }) {
    const [mobileMenu, setmobileMenu] = useState(false)
    const handleTogel = () => {
        setmobileMenu(!mobileMenu)
    }
    const userDetails = JSON.parse(sessionStorage.getItem("userDetails")) || {}

    return (
        <section className={`main-wrapper
          ${(userDetails.user.type == "Admin" || userDetails.user.type == "Employee") ? "saas-container" : ""}  
         ${mobileMenu ? "slide-nav" : ""}
         `}>
            {
                (userDetails.user.type == "Admin" || userDetails.user.type == "Employee") ? "" :
                    <Header handleTogel={handleTogel} />
            }
            <SideBar />
            {children}
        </section>
    )
}

export default MainLayout
